import React from 'react'
import { Documentos } from '../Documentos/Documentos'

export const Documento = () => {
  return (
    <div className='documento'>
      <h1 className='titulodocumentos'>DOCUMENTOS</h1>
      <hr className='hrDocumento'/>
      <Documentos/>
    </div>
  )
}
